// extracted by mini-css-extract-plugin
export default {"container":"AdvertPanelContent_container_lWkxq","content":"AdvertPanelContent_content_bBIQF"};